import { routes } from "@/router";
import { useTranslation } from "react-i18next";
import { HiOutlineCheckCircle } from "react-icons/hi2";
import { generatePath, useNavigate } from "react-router-dom";

import Button from "@/components/atoms/Button";
import FeaturedText from "@/components/molecules/FeaturedText";

type Props = {
  productId: string;
};

const ProductCreatedFeaturedText = ({ productId }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <FeaturedText
        featuredIcon={{ icon: HiOutlineCheckCircle, color: "success", size: "lg" }}
        heading={t("predictive.product.first.title")}
        body={t("predictive.product.first.description")}
        size={"lg"}
      >
        <div className={"flex justify-center gap-3"}>
          <Button
            label={t("predictive.product.create")}
            variants={"secondary"}
            onClick={() => window.location.reload()}
          />
          <Button
            label={t("predictive.campaign.create")}
            onClick={() => navigate(generatePath(routes.campaign.create, { productId }))}
          />
        </div>
      </FeaturedText>
    </div>
  );
};

export default ProductCreatedFeaturedText;
